import React from "react";
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import IndicatorManager from "@/components/indicators/IndicatorManager";

const IndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <IndicatorManager />
      </Box>
    </Box>
  );
};

export default IndicatorPage;
